@if (!formControl) {
  <div
    class="d-flex gap-2"
    [ngClass]="{
      'global-input-mat': global(),
    }"
  >
    <mat-form-field class="cursor-pointer">
      <input
        matInput
        readonly
        [matDatepicker]="datepicker"
        [(ngModel)]="selectedDate"
        [min]="minDate()"
        [max]="maxDate()"
        [placeholder]="placeholderDate()"
        (click)="onButtonClick()"
        (dateChange)="onDateChange($event)"
      />
      <button
        (click)="onButtonClick()"
        class="btn calendar-btn-m bi bi-calendar3 btn-primary"
        aria-label="Open date picker"
      ></button>
      <mat-datepicker #datepicker />
    </mat-form-field>
    <ui-form-timepicker
      class="w-100"
      [selectedDate]="selectedDate()"
      [placeholderTime]="placeholderTime()"
      (timeChange)="onTimeChange($event)"
    ></ui-form-timepicker>
  </div>
}

@if (formControl) {
  <div
    class="d-flex gap-2"
    [ngClass]="{
      'global-input-mat': global(),
    }"
  >
    <mat-form-field class="cursor-pointer">
      <input
        matInput
        readonly
        [matDatepicker]="datepicker"
        [formControl]="formControl"
        [min]="minDate()"
        [max]="maxDate()"
        [placeholder]="placeholderDate()"
        (click)="onButtonClick()"
        (dateChange)="onDateChange($event)"
      />
      <button
        (click)="onButtonClick()"
        class="btn calendar-btn-m bi bi-calendar3 btn-primary"
        aria-label="Open date picker"
      ></button>
      <mat-datepicker #datepicker />
    </mat-form-field>
    <ui-form-timepicker [formControl]="formControl"></ui-form-timepicker>
  </div>
}

@if (control() && control()!['touched']) {
  <ui-validation-form [control]="control()!"></ui-validation-form>
}
@if (description()) {
  <div class="form-text">{{ description() }}</div>
}
